// fields of com.six.anna.common.model.ChallengeFile
enum CHALLENGE_FIELD {
    challengeComment = "challengeComment",
    uploadChallengeISINs = "uploadChallengeISINs",
    additionalDocuments = "additionalDocuments",
    challengePriority = "challengePriority",
}

export default CHALLENGE_FIELD